// WHERE A NOTIFICATION OPENS — one rule for the bell rows, the /inbox page and
// the toast (NotificationRow, GlobalNotification), handed to
// openNotificationTarget. A server row carries its own `href`, which wins.
// The comms-phone pipeline's channel types carry none (server
// channelInbound.js _notify: 'channel_message', 'channel_missed_call' with
// metadata.partyId — the sender's CRM party, null for an unknown sender):
// those open the sender's contact in the CRM, /crm?contact=<partyId>, or the
// CRM inbox, /crm?view=inbox, for an unknown sender (comms-ui, 2026-09-30).
// Any other type without an href opens nothing (''). Self-contained (frank).
export const notificationHrefOf = (notif) => {
  const n = notif && typeof notif === 'object' ? notif : {}
  const own = n.href == null ? '' : String(n.href)
  if (own) return own
  const meta = n.metadata && typeof n.metadata === 'object' ? n.metadata : {}
  if (meta.kind === 'meeting_starting' && meta.calendarEventId != null) return '/calendar'
  if (n.type === 'channel_message' || n.type === 'channel_missed_call') {
    const party = meta.partyId == null ? '' : String(meta.partyId).trim()
    return party ? '/crm?contact=' + encodeURIComponent(party) : '/crm?view=inbox'
  }
  return ''
}
